import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { dramas } from "@/mocks/dramas";

const categoryMeta = [
  { key: "都市", icon: "ri-building-2-line", desc: "逆袭、职场与现实议题" },
  { key: "古装", icon: "ri-ancient-gate-line", desc: "权谋、宫廷与江湖恩怨" },
  { key: "玄幻", icon: "ri-sword-line", desc: "修仙、异能与山海秘闻" },
  { key: "悬疑", icon: "ri-spy-line", desc: "烧脑线索与反转叙事" },
  { key: "家庭", icon: "ri-home-heart-line", desc: "亲情、婚恋与生活流" },
  { key: "甜宠", icon: "ri-heart-3-line", desc: "契约婚姻与日常撒糖" },
  { key: "民国", icon: "ri-store-3-line", desc: "旧时光里的烟火气" },
];

export default function CategorySection() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="按题材找剧"
          title="七个高频题材，快速定位你要的爆料"
          description="不同题材的观众关注点完全不同：看古装想知道服化道，看现实题材想知道拍摄尺度，看悬疑则想知道线索埋点。"
        />

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categoryMeta.map((item) => {
            const count = dramas.filter((drama) => drama.tags.includes(item.key)).length;
            return (
              <Link
                key={item.key}
                to={`/dramas?cat=${encodeURIComponent(item.key)}`}
                className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <span className="flex flex-col">
                  <strong className="font-heading text-base font-semibold text-foreground-950">
                    {item.key}
                  </strong>
                  <span className="mt-1 text-xs leading-relaxed text-foreground-600">
                    {item.desc}
                  </span>
                  <span className="mt-2 text-xs text-accent-700">
                    {count > 0 ? `${count} 部在库` : "即将上线"}
                  </span>
                </span>
              </Link>
            );
          })}

          <Link
            to="/cast"
            className="group flex items-start gap-4 rounded-lg border border-dashed border-primary-200 bg-primary-50/60 p-5 transition-colors hover:border-primary-400"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-team-line text-xl"></i>
            </span>
            <span className="flex flex-col">
              <strong className="font-heading text-base font-semibold text-foreground-950">
                演员表查询
              </strong>
              <span className="mt-1 text-xs leading-relaxed text-foreground-700">
                按演员姓名反查参演作品与代表作
              </span>
              <span className="mt-2 text-xs text-primary-700">进入演员库 →</span>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}